import React from 'react'

const UserAccountDetail = ({ accountDetail }) => {

    console.log("accountDetail", accountDetail)
    return (
        <>
            <div className="container">
                {
                    accountDetail && (
                        <div className="row">




                            <div className="col-lg-6">
                                <h4>Account Title</h4>
                                <p>{accountDetail?.account_title}</p>
                            </div>

                            <div className="col-lg-6">
                                <h4>Account Number</h4>
                                <p>{accountDetail?.account_number}</p>
                            </div>
                            <div className="col-lg-6">
                                <h4>Bank Name</h4>
                                <p>{accountDetail?.bank_name}</p>
                            </div>
                            <div className="col-lg-6">
                                <h4>Currency</h4>
                                <p>{accountDetail?.currency}</p>
                            </div>
                        </div>
                    )
                }
            </div>
        </>
    )
}

export default UserAccountDetail